import React from "react";
import ModalWrapper from './ModalWrapper';
import PopoverLogin from './PopoverLogin';

const FormLogin = props => {
  return(
    <ModalWrapper
      {...props}
    >
      <PopoverLogin/>
    </ModalWrapper>
  );
};

export default FormLogin;


// WEBPACK FOOTER //
// ./src/components/ModalLogin.js